module.exports = "https://dev.stanwinstonschool.com/evildead_2_poster_org.b3b0b2f2340680fe6e3d18f2926d6e10.jpg";